import { useEffect, useState } from "react";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { goCta } from "@/lib/industry";

const host = (u) => { try { return new URL(u).hostname; } catch { return u; } };

export function CtaChooser() {
  const [req, setReq] = useState(null);
  useEffect(() => {
    const on = (e) => setReq(e.detail);
    window.addEventListener("cta-choose", on);
    return () => window.removeEventListener("cta-choose", on);
  }, []);
  if (!req) return null;
  const last = localStorage.getItem(`cta_loc_${req.ctx.builder_id}`);
  const pick = (l) => { goCta(l, req.ctx); setReq(null); };
  return (
    <Dialog open onOpenChange={() => setReq(null)}>
      <DialogContent className="max-w-sm z-[80]" data-testid="cta-chooser">
        <DialogHeader><DialogTitle className="font-serif text-2xl">{req.group.label}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">Choose your location</p>
        <div className="space-y-2 mt-2">
          {req.group.options.map((l, i) => (
            <button key={l.url} onClick={() => pick(l)} className={`w-full flex items-center gap-3 rounded-2xl border px-4 py-3 text-left hover:border-slate-500 transition-colors ${last && l.location === last ? "border-slate-900 bg-slate-50" : ""}`} data-testid={`cta-chooser-option-${i}`}>
              <MapPin className="w-4 h-4 text-slate-500 shrink-0" />
              <span className="flex-1 font-semibold text-sm">{l.location || host(l.url)}{last && l.location === last && <span className="ml-2 text-xs font-normal text-slate-500">Last used</span>}</span>
              <ArrowUpRight className="w-4 h-4 text-slate-400" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
